import "./style.scss";

import { Button } from "@mui/material";
import { Pending } from "components/Management/ModalContent";
import ModalBox from "components/Modal";
import AutocompleteFormComponent from "components/shared/FormComponent/AutocompleteFormComponent";
import StyledButton, { blackButtonStyles } from "components/shared/StyledButton";
import { whiteButton } from "components/TitlesList";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

type TProps = {
    close: (success: boolean) => void;
    handleSwitchCompany: (companyId: number, reason: string) => void;
    companyId: number;
};
type TReasonsSelect = { type: string; description: string }[];

const SwitchCompanyModal = ({ companyId, close, handleSwitchCompany }: TProps) => {
    const [t] = useTranslation();
    const [isProcessing, setIsProcessing] = useState(false);

    const reasonsSelect: TReasonsSelect = [
        { type: "1", description: t("AdminPanel.CrealoSpaceDelivery") },
        { type: "2", description: t("AdminPanel.GiveAccesToUsers") },
        { type: "3", description: t("AdminPanel.EmailRequestFollowDemand") },
        { type: "4", description: t("AdminPanel.DataIntegration") },
        { type: "5", description: t("AdminPanel.VerificationAfterUpdate") },
    ];

    const {
        control,
        handleSubmit,
        watch,
        formState: { errors },
    } = useForm({
        defaultValues: {
            reasonsOption: null,
        },
        mode: "all",
    });

    const watchReasons = watch("reasonsOption");

    const renderReasonsOptions = (props: any, option: any) => (
        <li {...props} className="switch-company-reasons-list">
            <span>{option.type}</span>
            <div className="separator"></div>
            <span>{option.description}</span>
        </li>
    );

    const onSubmitReason = async (formData: any) => {
        const reason: string = formData.reasonsOption.description;
        setIsProcessing(true);
        await handleSwitchCompany(companyId, reason);
        setIsProcessing(false);
        close(true);
    };

    return (
        <>
            <ModalBox open={isProcessing} onClose={() => {}} showCloseButton={false}>
                <Pending phrase={t("Settings.APIKey.Switching")} />
            </ModalBox>
            <div className="switch-company-wrapper">
                <form onSubmit={handleSubmit(onSubmitReason)}>
                    <div className="switch-company-description">
                        <span>{t("AdminPanel.SwitchCompanyImpact")}</span>
                    </div>
                    <div className="switch-company-input">
                        <AutocompleteFormComponent
                            label={t("AdminPanel.SwitchCompanyReason")}
                            options={reasonsSelect}
                            renderOptionText={(option: any) => `${option.type} | ${option.description}`}
                            renderOption={renderReasonsOptions}
                            control={control}
                            controlName="reasonsOption"
                            error={errors.reasonsOption}
                            required
                            customRequiredMessage={t("AdminPanel.ChooseAccessReason")}
                        />
                    </div>
                    <div className="switch-company-buttons">
                        <Button
                            variant="contained"
                            sx={{
                                ...blackButtonStyles,
                                textTransform: "none",
                                fontFamily: "Poppins",
                            }}
                            fullWidth
                            type="submit"
                            disabled={watchReasons === null}
                        >
                            {t("AdminPanel.ValidateSwitchCompany")}
                        </Button>
                        <StyledButton
                            onClick={() => close(false)}
                            fullWidth
                            sx={{ ...whiteButton, color: "#ED6E6E", fontFamily: "Poppins" }}
                        >
                            {t("AdminPanel.Cancel")}
                        </StyledButton>
                    </div>
                </form>
            </div>
        </>
    );
};
export default SwitchCompanyModal;
